<template >
  <base-dialog-form ref="gestTesseraDialog" :title="computedTitle" :text="nome" color="secondary"
    icon="mdi-credit-card-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'"
            :disabled="change2saveTesseraFront || change2saveTesseraBack || change2saveDiploma" @click="saveTessera"
            color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteTessera" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-layout class="mx-10" row>
      <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-tune</v-icon>
          {{ $t("parameters") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-text-box-multiple-outline</v-icon>
          {{ $t("terms_and_conditions") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-file-image-outline</v-icon>
          {{ $t("image") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
          {{ $t("front_template") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
          {{ $t("back_template") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
          {{ $t("diploma_template") }}
        </v-tab>
      </v-tabs>
    </v-layout>
    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item>
        <v-container>
          <form>
            <v-row>
              <v-col md="2" cols="6">
                <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="order"
                  :label="$t('sort_number')" hide-details="auto"></v-text-field>
              </v-col>

              <v-col md="2" cols="6">
                <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="prezzo" :label="$t('price')"
                  hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-text-field type="number" v-model.number="sconto" :disabled="method === 'VIEW'"
                  :label="$t('number_of_discount')" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="1" cols="6">
                <v-text-field v-model="onlyAfterNumYear" :disabled="method === 'VIEW'"
                  :label="$t('buy_only_after_n_season')"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-switch :disabled="method === 'VIEW'" v-model="attiva" :label="$t('active_f_s')"></v-switch>
              </v-col>
              <v-col md="1" cols="3">
                <v-checkbox v-model="onlyDirigenti" :disabled="method === 'VIEW'" :label="$t('only_executive')"
                  :value="true"></v-checkbox>
              </v-col>
              <v-col md="1" cols="3">
                <v-checkbox v-model="ifDirigente" :disabled="method === 'VIEW'" :label="$t('executive')"
                  :value="true"></v-checkbox>
              </v-col>
              <v-col md="1" cols="3">
                <v-checkbox v-model="ifTecnico" :disabled="method === 'VIEW'" :label="$t('technician')"
                  :value="true"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" cols="12">
                <v-text-field v-model="nome" :disabled="method === 'VIEW'" :label="$t('name')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="12">
                <v-text-field v-model="categoria" :disabled="method === 'VIEW'" :label="$t('category')" :rules="required"
                  hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="3" cols="12">
                  <v-select :items="listQualifiche" v-model="qualifiche" :label="$t('qualifications')"
                      :menu-props="{ maxHeight: '400' }" item-text="description"
                      :disabled="method === 'VIEW'" item-value="qualifica" multiple
                      chips color="primary"></v-select>
              </v-col>
              <v-col md="3" cols="12">
                <v-select v-model="discipline" :disabled="method === 'VIEW'" :items="listDiscipline"
                  :menu-props="{ maxHeight: '400' }" :label="$t('disciplines')" multiple required chips dense
                  color="primary" :hint="$t('pick_your_disciplines')"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-select v-model="upgrade" item-value="tesId" item-text="nome" :disabled="method === 'VIEW'"
                  :items="listAltreTessere" :menu-props="{ maxHeight: '400' }" :label="$t('upgrade')" multiple required
                  chips dense color="primary" :hint="$t('pick_cards_for_upgrade')"></v-select>
              </v-col>
              <v-col :md="currentEnteTessera ? 2 : 3" :cols="currentEnteTessera ? 8 : 12">
                <v-select item-value="tesId" item-text="nome" :disabled="method === 'VIEW'" v-model="enteTesId"
                  :items="listEnteTessere" :menu-props="{ maxHeight: '400' }" :label="$t('card') + ' ' + enteRagSoc"
                  required color="primary" persistent-hint></v-select>
              </v-col>
              <v-col v-if="currentEnteTessera && currentEnteTessera.prezzo < prezzo" md="1" cols="4">
                <v-icon color="success" large class="mr-2">mdi-cash-plus</v-icon> {{ prezzo - currentEnteTessera.prezzo }}
              </v-col>
              <v-col v-if="currentEnteTessera && currentEnteTessera.prezzo === prezzo" md="1" cols="4">
                <v-icon color="primary" large class="mr-2">mdi-equal</v-icon>
              </v-col>
              <v-col v-if="currentEnteTessera && currentEnteTessera.prezzo > prezzo" md="1" cols="4">
                <v-icon color="error" large class="mr-2">mdi-alert</v-icon>{{ prezzo - currentEnteTessera.prezzo }}
              </v-col>

              <v-col md="3" cols="12">
                <v-autocomplete v-model="idProduct" clearable :disabled="method === 'VIEW'" :items="listProduct"
                  item-value="value" item-text="text" :label="$t('gift')"></v-autocomplete>
              </v-col>

              <v-col md="8" cols="12">
                <v-select v-model="modPag" :items="listPayment" :disabled="method === 'VIEW'"
                  :menu-props="{ maxHeight: '400' }" multiple required dense chips color="primary"
                  :hint="$t('pick_your_payments')" :label="$t('payment')" persistent-hint></v-select>
              </v-col>
              <v-col md="2" cols="12">
                <v-switch :disabled="method === 'VIEW'" v-model="forceOrderApprove"
                  :label="$t('force_order_approve')"></v-switch>
              </v-col>
              <v-col md="2" cols="12">
                <v-select v-model="certRequired" :items="listTypeCertValid" :disabled="method === 'VIEW'"
                  :menu-props="{ maxHeight: '400' }" :label="$t('check_cert')" required color="primary"
                  persistent-hint></v-select>
              </v-col>
            </v-row>
            <v-card>
              <v-row>
                <v-col cols="12">{{ $t("discount_for_age") }}
                  <v-btn class="mx-2" v-if="method !== 'VIEW'" fab dark small style="float: right" color="success"
                    @click="addScontoEta()">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-card-text>
                <v-row v-if="scontoEta && scontoEta.length > 0">
                  <v-col md="6" cols="12" v-for="sconto in scontoEta" v-bind:key="sconto.id">
                    <v-card>
                      <v-container>
                        <v-row>
                          <v-col md="3" cols="12">
                            <v-text-field :rules="required" type="number" :disabled="method === 'VIEW'"
                              v-model.number="sconto.from" :label="$t('age_from')"></v-text-field>
                          </v-col>
                          <v-col md="3" cols="12">
                            <v-text-field :rules="required" type="number" :disabled="method === 'VIEW'"
                              v-model.number="sconto.to" :label="$t('age_to')"></v-text-field>
                          </v-col>
                          <v-col md="4" cols="6">
                            <v-text-field :rules="required" type="number" :disabled="method === 'VIEW'"
                              v-model.number="sconto.prezzo" :label="$t('price')"></v-text-field>
                          </v-col>
                          <v-col md="2" cols="6">
                            <v-btn class="mx-2" fab dark small style="float: right" color="error"
                              @click="deleteScontoEta(sconto.id)">
                              <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </form>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <form>
            <v-row>
              <v-col md="12" cols="12">
                <v-divider />
                <br />
                {{ $t("description") }}
                <br />
                <br />
                <tiptap-vuetify :extensions="extensions" v-model="descr"></tiptap-vuetify>
              </v-col>
              <v-col md="12" cols="12">
                <v-divider />
                <br />
                {{ $t("condition_and_terms") }}
                <br />
                <br />
                <tiptap-vuetify :extensions="extensions" v-model="condizioni"></tiptap-vuetify>
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col md="6" cols="12" class="text-center">
              <v-color-picker :disabled="method === 'VIEW'" v-model="hexColor" mode="hexa" class="ma-2"
                dot-size="30"></v-color-picker>
            </v-col>
            <v-col md="6" cols="12" class="text-center">
              <my-img-uploader ref="imageUploader" v-model="image" :readOnly="method === 'VIEW'"
                :width="orientationCard === 'vertical' ? 275 : 400" :height="orientationCard === 'vertical' ? 400 : 275"
                :placeholder="$t('click_drag_here')"></my-img-uploader>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col cols="12">
              <html-designer ref="htmlDesignerFront" componentKey="template_front" v-model="cardTemplateFront"
                :selectableField="selectableField" @change2save="changedTesseraFront" format="A7" :orientation="orientationCard === 'vertical' ? 'portrait' : 'landscape'
                  " />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col cols="12">
              <html-designer ref="htmlDesignerBack" componentKey="template_back" v-model="cardTemplateBack"
                @change2save="changedTesseraBack" :selectableField="selectableField" format="A7" :orientation="orientationCard === 'vertical' ? 'portrait' : 'landscape'
                  " />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col cols="12">
              <html-designer ref="htmlDesignerDiploma" componentKey="template_back" v-model="diplomaTemplate"
                @change2save="changedDiploma" :selectableField="selectableField" format="A5" orientation="landscape" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyImageUploader from "@/components/base/MyImageUploader.vue";
import htmlDesigner from "@/components/base/htmlDesigner.vue";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "gest-tessera",
  components: {
    TiptapVuetify,
    "html-designer": htmlDesigner,
    "my-img-uploader": MyImageUploader,
  },
  data() {
    return {
      tabs: null,
      tesId: null,
      method: null,
      files: [],
      listProduct: [],
      scontoEta: [],
      listDiscipline: [],
      listEnteTessere: [],
      listAltreTessere: [],
      listPayment: [],
      listQualifiche: [],
      condizioni: null,
      discipline: null,
      onlyAfterNumYear: null,
      cardTemplateFront: null,
      cardTemplateBack: null,
      diplomaTemplate: null,
      change2saveTesseraFront: false,
      change2saveTesseraBack: false,
      change2saveDiploma: false,
      nome: null,
      qualifiche: [],
      categoria: null,
      descr: null,
      hexColor: null,
      prezzo: 0,
      order: null,
      sconto: null,
      image: null,
      certRequired: null,
      idProduct: null,
      enteTesId: null,
      upgrade: [],
      attiva: false,
      forceOrderApprove: false,
      modPag: [],
      onlyDirigenti: false,
      ifDirigente: false,
      ifTecnico: false,
      orientationCard: "horizontal",
      listTypeCertValid: [
        { value: null, text: this.$t("no_cert_required") },
        { value: 1, text: this.$t("cert_required_warning") },
        { value: 2, text: this.$t("cert_required_block") },
        { value: 3, text: this.$t("cert_valid_warning") },
        { value: 4, text: this.$t("cert_valid_block") },
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
      selectableField: [
        {
          type: "text",
          value: "userFullname",
          dex: this.$t("surname_name"),
        },
        {
          type: "text",
          value: "userName",
          dex: this.$t("name"),
        },
        {
          type: "text",
          value: "userSurname",
          dex: this.$t("surname"),
        },
        {
          type: "text",
          value: "season",
          dex: this.$t("season"),
        },
        {
          type: "text",
          value: "numTessera",
          dex: this.$t("number_affiliation_card"),
        },
        {
          type: "text",
          value: "tesDex",
          dex: this.$t("card_description"),
        },
        {
          type: "text",
          value: "ifTecnico",
          dex: this.$t("technician=>X"),
        },
        {
          type: "text",
          value: "ifDirigente",
          dex: this.$t("executive=>X"),
        },
        {
          type: "text",
          value: "asdRagSoc",
          dex: this.$t("asd_rag_soc"),
        },
        {
          type: "text",
          value: "asdNome",
          dex: this.$t("asd_name"),
        }, {
          type: "text",
          value: "asdInsRagSoc",
          dex: this.$t("asd_ins_rag_soc"),
        },
        {
          type: "text",
          value: "asdInsNome",
          dex: this.$t("asd_ins_name"),
        },
        {
          type: "text",
          value: "userDateBirth",
          dex: this.$t("birth_date"),
        },
        {
          type: "text",
          value: "userBirthCity",
          dex: this.$t("birth_city"),
        },
        {
          type: "text",
          value: "qualifica",
          dex: this.$t("qualify"),
        }, {
          type: "text",
          value: "categoria",
          dex: this.$t("category"),
        },
        {
          type: "text",
          value: "userCfiscale",
          dex: this.$t("fiscal_code"),
        },
        {
          type: "text",
          value: "discipline",
          dex: this.$t("disciplines"),
        },
        {
          type: "image",
          value: "userFoto",
          dex: this.$t("user_picture"),
        },
      ],
    };
  },
  methods: {
    addScontoEta() {
      this.scontoEta.push({
        id: this.scontoEta.length + 1,
        from: null,
        to: null,
        prezzo: 0,
      });
    },
    deleteScontoEta(id) {
      this.scontoEta = this.scontoEta.filter((sconto) => {
        return sconto.id !== id;
      });
    },
    open(method, tesId) {
      this.method = method;
      this.tesId = tesId;
      this.loadData();
      this.$refs.gestTesseraDialog.open();
    },
    changedTesseraFront(value) {
      this.change2saveTesseraFront = value;
    },
    changedTesseraBack(value) {
      this.change2saveTesseraBack = value;
    },
    changedDiploma(value) {
      this.change2saveDiploma = value;
    },
    loadData() {
      let _ = this;
      _.tabs = null;
      _.change2saveTesseraFront = false;
      _.change2saveTesseraBack = false;
      _.change2saveDiploma = false;
      _.cardTemplateFront = null;
      _.cardTemplateBack = null;
      _.diplomaTemplate = null;
      _.nome = "";
      _.qualifiche = [];
      _.categoria = "";
      _.descr = "";
      _.condizioni = "";
      _.hexColor = "";
      _.cardTemplateFront = "";
      _.cardTemplateBack = "";
      _.diplomaTemplate = "";
      _.prezzo = 0;
      _.order = 0;
      _.sconto = 0;
      _.image = null;
      _.orientationCard = "horizontal";
      _.attiva = true;
      _.onlyDirigenti = false;
      _.forceOrderApprove = false;
      _.ifDirigente = false;
      _.ifTecnico = false;
      _.idProduct = null;
      _.enteTesId = null;
      _.upgrade = [];
      _.scontoEta = [];
      _.modPag = [];
      _.onlyAfterNumYear = null;
      _.certRequired = null;
      _.discipline = null;
      if (_.tesId !== null) {
        let url = "/auth/tesseramenti/getTessera/" + _.tesId;
        // Eventi aperti
        _.chiamataAxios("GET", url, { dialogLoader: true }).then((response) => {
          _.nome = response.data.nome;
          _.qualifiche = response.data.qualifiche.map(el => {return el.qualifica});
          _.categoria = response.data.categoria;
          _.descr = response.data.descr;
          _.condizioni = response.data.condizioni;
          _.certRequired = response.data.certRequired;
          _.hexColor = response.data.hexColor;
          _.cardTemplateFront = response.data.cardTemplateFront
            ? response.data.cardTemplateFront
            : "";
          _.cardTemplateBack = response.data.cardTemplateBack
            ? response.data.cardTemplateBack
            : "";
          _.diplomaTemplate = response.data.diplomaTemplate
            ? response.data.diplomaTemplate
            : "";

          _.prezzo = response.data.fullPrice;
          _.order = response.data.order;
          _.sconto = response.data.sconto;
          _.image = response.data.image;
          _.orientationCard = response.data.orientationCard;
          _.attiva = response.data.attiva == 1 ? true : false;
          _.onlyDirigenti = response.data.onlyDirigenti === 1 ? true : false;
          _.forceOrderApprove = response.data.forceOrderApprove === 1 ? true : false;
          _.ifDirigente = response.data.ifDirigente === 1 ? true : false;
          _.ifTecnico = response.data.ifTecnico == 1 ? true : false;
          _.idProduct = response.data.idProduct;
          _.enteTesId = response.data.enteTesId;
          _.upgrade = response.data.upgrade;
          _.modPag = response.data.modPag;
          let totSconti = 0;
          _.scontoEta = response.data.scontoEta.map((sconto) => {
            sconto.id = totSconti;
            totSconti++;
            return sconto;
          });
          _.onlyAfterNumYear = response.data.onlyAfterNumYear;
          _.discipline = response.data.discipline.map((disciplina) => {
            return disciplina.value;
          });
        });
      }
      _.listPayment = [];
      _.chiamataAxios("GET", "/auth/portal/listAllModPagamento").then(
        (response) => {
          _.listPayment = response.data
            .filter((pag) => {
              return pag.attivo === 1;
            })
            .map(function (item) {
              return { value: item.pagId, text: item.descr };
            });
        }
      );
      
      _.listQualifiche = [];
      _.chiamataAxios("GET", "/auth/tesseramenti/getAllEnabledQualifiche").then(
        (response) => {
          _.listQualifiche = response.data
        }
      );

      // Lista prodotti
      _.chiamataAxios("GET", "/auth/prodotti/listProducts").then((response) => {
        _.listProduct = response.data.map(function (prd) {
          return {
            value: prd.idProduct,
            text: prd.productCode + " - " + prd.descr,
          };
        });
      });
      // Lista tessere ente
      _.listEnteTessere = [];
      _.chiamataAxios("GET", "/auth/tesseramenti/listEnteTessere").then(
        (response) => {
          _.listEnteTessere = response.data;
        }
      );
      // Lista altre tessere asd
      _.listAltreTessere = [];
      _.chiamataAxios("GET", "/auth/tesseramenti/listTessere/all").then(
        (response) => {
          _.listAltreTessere = response.data.tessere;
        }
      );
      // Lista discipline
      _.chiamataAxios("GET", "/auth/ente/listDiscipline").then((response) => {
        _.listDiscipline = response.data.map(function (disciplina) {
          return {
            value: disciplina.idDisciplina,
            text: disciplina.descr,
          };
        });
      });
    },
    deleteTessera(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/tesseramenti/deleteTessera/" + _.tesId,
            {
              dialogLoader: true,
              msg: "always",
            }
          ).then((response) => {
            if (response.msg.esito) {
              _.$emit("isUpdated", "true");
              _.$refs.gestTesseraDialog.close();
            }
          });
        }
      });
    }, 
    saveTessera: function () {
      let _ = this;
      let url = "/auth/tesseramenti/saveTessera/" + _.tesId;
      let tesseraObj = {
        nome: _.nome,
        qualifiche: _.qualifiche,
        categoria: _.categoria,
        descr: _.descr,
        condizioni: _.condizioni,
        hexColor: _.hexColor,
        prezzo: _.prezzo,
        order: _.order,
        sconto: _.sconto,
        certRequired: _.certRequired,
        attiva: _.attiva ? 1 : 0,
        onlyDirigenti: _.onlyDirigenti ? 1 : 0,
        forceOrderApprove: _.forceOrderApprove ? 1 : 0,
        ifDirigente: _.ifDirigente ? 1 : 0,
        ifTecnico: _.ifTecnico ? 1 : 0,
        cardTemplateFront:
          _.cardTemplateFront !== "" ? _.cardTemplateFront : null,
        cardTemplateBack: _.cardTemplateBack !== "" ? _.cardTemplateBack : null,
        diplomaTemplate: _.diplomaTemplate !== "" ? _.diplomaTemplate : null,
        idProduct: _.idProduct,
        enteTesId: _.enteTesId,
        upgrade: _.upgrade,
        modPag: _.modPag,
        scontoEta: _.scontoEta.filter((sconto) => {
          return sconto.prezzo !== 0;
        }),
        onlyAfterNumYear: _.onlyAfterNumYear,
        discipline: _.discipline,
      };
      if (_.$refs.imageUploader) {
        _.$refs.imageUploader.updateImage();
        tesseraObj.image = _.image;
      }

      let method = "POST";
      if (_.method == "ADD") {
        url = "/auth/tesseramenti/createTessera";
        method = "PUT";
      }
      _.chiamataAxios(method, url, {
        dialogLoader: true,
        msg: "always",
        body: tesseraObj,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", "true");
          _.$refs.gestTesseraDialog.close();
        }
      });
    },
  },

  computed: {
    enteRagSoc: function () {
      return window.systemData &&
        window.systemData.ente &&
        window.systemData.ente.ragSoc
        ? window.systemData.ente.ragSoc
        : "";
    },
    currentEnteTessera: function () {
      if (!this.enteTesId) return false;
      let enteTessera = this.listEnteTessere.find(el => {
        return el.tesId === this.enteTesId;
      })
      return enteTessera
    },
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_affiliation_card");
      else if (this.method === "VIEW") return this.$t("view_affiliation_card");
      else if (this.method === "ADD") return this.$t("create_affiliation_card");
      else return "";
    },
  },
};
</script>